
<template>
  <div>
    <v-data-table
      :headers="headers"
      :items-per-page="10"
      :items="comp_enrolleds"
      :search="search"
    >
      <template v-slot:top>
        <v-text-field  v-model="search" label="Buscar" class="mx-4"></v-text-field>
      </template>
      <template v-slot:[`item.email`]="{ item }">
        <div class="d-flex align-center">
          <span>{{ item.email }}</span>
          <v-tooltip top color="black">
            <template v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                icon
                x-small
                color="primary"
                class="ml-1"
                :loading="resendingEmailById[item.id] === true"
                @click="resendConfirmEmail(item)"
                :disabled="item.status == 'confirmed'"
              >
                <v-icon small>mdi-email-sync-outline</v-icon>
              </v-btn>
            </template>
            Reenviar e-mail de confirmação
          </v-tooltip>
        </div>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <v-btn small text color="primary" @click="openDialogAndShowDoneFormAnswers(item)" rounded outlined>
          <v-icon left>mdi-clipboard-text</v-icon>VER
        </v-btn>

        <v-btn small text color="primary" @click="downloadPdf(item)" rounded outlined class="ml-2">
          <v-icon left>mdi-download</v-icon>PDF
        </v-btn>
      </template>

      <template v-slot:[`item.birthdate`]="{ item }">
        {{ $dayjs().diff($dayjs(item.birthdate).format('YYYY-MM-DD'), 'year' )}} anos
      </template>

      <template v-slot:[`item.country`]="{ item }">
        {{ countries_map[item.country] != null ? countries_map[item.country] : item.country }}
      </template>

      <template v-slot:[`item.status`]="{ item }">
        <v-row>
          <v-col cols="12" class="pa-0 pt-1 mt-4">
            <v-chip small :color="status_chips_map[item.status].color">
              <v-icon small class="mr-2">{{status_chips_map[item.status].icon}}</v-icon>{{status_chips_map[item.status].title}} 
            </v-chip>
          </v-col>
          <v-col cols="12" class="pa-0 pt-1 mb-5">
            <v-btn v-if="item.status == 'missed'"  small text color="primary" @click="manualEnrollConfirm(item)" rounded outlined >
              <v-icon left>mdi-clipboard-text</v-icon> CONFIRMAR MANUALMENTE
            </v-btn>
          </v-col>
        </v-row>
      </template>
    </v-data-table>

    <dialog-enrollment-done-form
      v-if="dialog_one_enrolled"
      :dialog="dialog_one_enrolled" 
      :selected_done_form="enrolled"
      :course_status="course.status"
      @closeDialog="handleCloseDialog" 
      @setDoneFormStatus="handleSetDoneFormStatus"
    />

    <dialog-loading loadingText="Salvando" v-if="saving"></dialog-loading>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index'

export default {
  name: 'ListEnrolleds',
  props: {
    course: {
      type: Object,
    },
    enrolleds:{
      type: Array,
    }
  },
  components: {
    DialogEnrollmentDoneForm: () => import ('../select_components/DialogEnrollmentDoneForm.vue'),
  },
  data() {
    return {
      // enrolleds: [],

      dialog_one_enrolled: false,

      status_chips_map: {
        // {pending: 1, confirmed: 10, canceled: 20, missed: 30}
        pending: { color: 'primary', title: 'Aguardando', icon: 'mdi-account-plus' },
        missed: { color: 'error', title: 'Esqueceu', icon: 'mdi-alert' },
        canceled: { color: 'error', title: 'Cancelado', icon: 'mdi-cancel' },
        confirmed: { color: 'success', title: 'Confirmado', icon: 'mdi-star' },
      },


      search: '',
      headers: [
        {text: '#', value: 'id'},
        {text: 'Aluno', value: 'name'},
        { text: 'E-mail', value: 'email' },
        // { text: 'Estado', value: 'state' },
        { text: 'País', value: 'country' },
        { text: 'Idade', value: 'birthdate' },
        //{ text: 'Instituição', value: 'institution' },
        { text: 'Status', value: 'status', align: 'center'},
        
        { text: 'Formulário da inscrição', value: 'actions', align: 'center', sortable: false},
      ],

      countries_map:{ 
        brazilian: 'Brasil', 
        argentine: 'Argentina', 
        colombian: 'Colombia', 
        uruguayan: 'Uruguai', 
        paraguayan: 'Paraguai', 
        peru: 'Peru', 
        // other: 'Outro', 
      },
      enrolled: {},
      saving: false,
      downloadingPdf: false,
      resendingEmailById: {}
    }
  },
  methods: {
    handleCloseDialog(){
      this.enrolled = {}
      this.dialog_one_enrolled = false
    },
    handleSetDoneFormStatus({value, id}){
      this.dialog_one_enrolled = false

      this.$emit('doneChangeDoneFormStatus',{value, id})
    },
    downloadPdf(item) {
      const done_form_id = item.done_form_id
      if (!done_form_id) {
        this.addNotification({type: 'error', msg: 'ID do formulário não encontrado'})
        return
      }

      this.downloadingPdf = true
      
      Api.DoneForm.downloadPdf(done_form_id)
        .then(response => {
          const file = new Blob([response.data], { type: 'application/pdf' })
          const fileURL = URL.createObjectURL(file)
          const link = document.createElement('a')
          link.href = fileURL
          const candidate_name = item.name?.replace(/\s+/g, '_') || 'candidato'
          link.setAttribute('download', `formulario_inscricao_${candidate_name}_${done_form_id}.pdf`)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          URL.revokeObjectURL(fileURL)
          this.addNotification({
            type: 'success',
            msg: 'PDF baixado com sucesso!'
          })
        })
        .catch(err => {
          console.error(err)
          this.addNotification({
            type: 'error',
            msg: 'Erro ao baixar PDF. Tente novamente.'
          })
        })
        .finally(() => {
          this.downloadingPdf = false
        })
    },
    openDialogAndShowDoneFormAnswers(enrolled){
      this.enrolled = {...enrolled}
      this.dialog_one_enrolled = true
    },
    resendConfirmEmail(item) {
      this.$set(this.resendingEmailById, item.id, true)
      Api.Enrolled.resendConfirmEmail(item.id)
        .then(() => {
          this.addNotification({
            type: 'success',
            msg: 'E-mail de confirmação reenviado com sucesso!'
          })
        })
        .catch(() => {
          this.addNotification({
            type: 'error',
            msg: 'Não foi possível reenviar o e-mail de confirmação.'
          })
        })
        .finally(() => {
          this.$set(this.resendingEmailById, item.id, false)
        })
    },
    manualEnrollConfirm(item){
      this.$swal({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Confirmar',
        title: 'Deseja confirmar manualmente a inscrição? A ação é irreversível.',
        icon: 'warning',
      }).then(( r )=>{
        if(r.isConfirmed) {

          let enrolled = { status: 'confirmed', id: item.id }

          this.saving = true
          Api.Enrolled.update(enrolled).then(r=>r.data).then(d=> {
            this.enrolleds.map(el=>{
              if(el.id == d.id){
                return el.status = d.status
              }
            })
            this.addNotification({type: 'success', msg: `Inscrição confirmada com sucesso!`})
          }).catch((err)=>{
            this.addNotification({type: 'error', msg: `Ops, ocorreu um erro...`})
          }).finally(()=> {
            this.saving = false
          })
        }
      })
    },  
    ...mapActions({
      addNotification: 'Notification/add',
    })
  },
  computed: {
    comp_enrolleds(){
      if (this.enrolleds.length){
        if ( false && ['done_selection', 'in_progress', 'done'].includes(this.course.status)){
          return this.enrolleds.filter(df=>df.status == 'homologated')
        }
      }
      return this.enrolleds
    },
    ...mapState({
      // data: state=> state.Module.state_var
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>